import { SVGAttributes } from "react";

export function PlusIcon(props: SVGAttributes<SVGSVGElement>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M27 16C27 16.2431 26.9034 16.4763 26.7315 16.6482C26.5596 16.8201 26.3264 16.9167 26.0833 16.9167H16.9167V26.0833C16.9167 26.3264 16.8201 26.5596 16.6482 26.7315C16.4763 26.9034 16.2431 27 16 27C15.7569 27 15.5237 26.9034 15.3518 26.7315C15.1799 26.5596 15.0833 26.3264 15.0833 26.0833V16.9167H5.91667C5.67355 16.9167 5.44039 16.8201 5.26849 16.6482C5.09658 16.4763 5 16.2431 5 16C5 15.7569 5.09658 15.5237 5.26849 15.3518C5.44039 15.1799 5.67355 15.0833 5.91667 15.0833H15.0833V5.91667C15.0833 5.67355 15.1799 5.44039 15.3518 5.26849C15.5237 5.09658 15.7569 5 16 5C16.2431 5 16.4763 5.09658 16.6482 5.26849C16.8201 5.44039 16.9167 5.67355 16.9167 5.91667V15.0833H26.0833C26.3264 15.0833 26.5596 15.1799 26.7315 15.3518C26.9034 15.5237 27 15.7569 27 16Z"
        fill="#C3C7D3"
      />
    </svg>
  );
}
